import { render, staticRenderFns } from "./GapDatasetBar.vue?vue&type=template&id=3ffbb63a&scoped=true"
import script from "./GapDatasetBar.vue?vue&type=script&lang=js"
export * from "./GapDatasetBar.vue?vue&type=script&lang=js"
import style0 from "./GapDatasetBar.vue?vue&type=style&index=0&id=3ffbb63a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbb63a",
  null
  
)

export default component.exports